import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as SendIcon } from './send.svg';

export const Send = IconHOC(SendIcon);
